module.exports = __webpack_public_path__ + "media/landing-page/omniva-bubble-74a1fe82.png";